import { render, staticRenderFns } from "./receive-table.vue?vue&type=template&id=d016745e&scoped=true&"
import script from "./receive-table.vue?vue&type=script&lang=js&"
export * from "./receive-table.vue?vue&type=script&lang=js&"
import style0 from "./receive-table.vue?vue&type=style&index=0&id=d016745e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d016745e",
  null
  
)

export default component.exports